module.exports = __webpack_public_path__ + "static/media/events.985f281c.svg";